import cn from "classnames";
import { toCssClass } from "utils/stringUtils";
import { type PublishedStatusType } from "enums";

import "components/common/PublishStatus/publishStatus.scss";

export type Props = {
  publishedStatus: PublishedStatusType;
  muted?: boolean;
};

const PublishStatus = ({ publishedStatus, muted }: Props) => {
  const className = cn("point", publishedStatus && toCssClass(publishedStatus));

  return publishedStatus ? (
    <div className="published-status">
      <span className={className} />
      <span className={cn("label", { muted })}>{publishedStatus}</span>
    </div>
  ) : null;
};

export default PublishStatus;
